import { Sidebar, Menu, MenuItem, Logo } from "react-mui-sidebar";

//Client Information Icons
import PersonIcon from "@mui/icons-material/Person";
import EmojiPeopleIcon from "@mui/icons-material/EmojiPeople";
import FamilyRestroomIcon from "@mui/icons-material/FamilyRestroom";

//Financial Icons
import ChecklistIcon from "@mui/icons-material/Checklist";
import SavingsIcon from "@mui/icons-material/Savings";
import CottageIcon from "@mui/icons-material/Cottage";
import ContentPasteIcon from "@mui/icons-material/ContentPaste";

//RiskProfile Icons
import StackedLineChartIcon from "@mui/icons-material/StackedLineChart";
import ImportContactsIcon from "@mui/icons-material/ImportContacts";

//Others Icon
import BarChartIcon from "@mui/icons-material/BarChart";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import InsightsIcon from "@mui/icons-material/Insights";

//Product Recommendation Icon
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";

export default function Navigator() {
  return (
    <Sidebar
      // width={"570px"}
      isCollapse={false}
      mode={"light"}
      userName={"Edwin"}
      designation="Sr. Architech"
      showProfile={true}
    >
      {/* <Logo
        href="/"
        img="/images/Logo.jpg"
        width="100"
        height="100"

        // img="https://adminmart.com/wp-content/uploads/2024/03/logo-admin-mart-news.png"
      >
        AdminMart
      </Logo> */}
      <img src="/images/Logo.jpg" alt="" width="256" height="110" />

      <Menu subHeading="Client Information">
        <MenuItem link="/application/personalinfo" icon={<PersonIcon />}>
          Personal Information
        </MenuItem>

        <MenuItem
          link="/application/trustedindividual"
          icon={<EmojiPeopleIcon />}
        >
          Trusted Individual
        </MenuItem>

        <MenuItem
          link="/application/dependantdetails"
          icon={<FamilyRestroomIcon />}
        >
          Dependant's Details
        </MenuItem>
      </Menu>
      <Menu subHeading="Financial Information">
        <MenuItem link="/application/objectives" icon={<ChecklistIcon />}>
          Objectives
        </MenuItem>

        <MenuItem link="/application/incomeandexpenses" icon={<SavingsIcon />}>
          Income & Expenses
        </MenuItem>

        <MenuItem
          link="/application/assetsandliabilities"
          icon={<CottageIcon />}
        >
          Assets & Liabilities
        </MenuItem>

        <MenuItem link="/application/currentplans" icon={<ContentPasteIcon />}>
          Current Plans
        </MenuItem>
      </Menu>
      <Menu subHeading="Risk Profile">
        <MenuItem
          link="/application/riskinvestment"
          icon={<StackedLineChartIcon />}
        >
          Investment Risk
        </MenuItem>

        <MenuItem link="/application/riskcka" icon={<ImportContactsIcon />}>
          CKA/CAR
        </MenuItem>
      </Menu>
      <Menu subHeading="Others">
        <MenuItem link="/application/needsanalysis" icon={<BarChartIcon />}>
          Needs Analysis
        </MenuItem>

        <MenuItem link="/application/affordability" icon={<AttachMoneyIcon />}>
          Affordability
        </MenuItem>

        <MenuItem link="/application/summary" icon={<InsightsIcon />}>
          Summary
        </MenuItem>
      </Menu>
      <Menu subHeading="Product Recommendation">
        <MenuItem
          link="/application/products/insurance"
          icon={<ShoppingCartIcon />}
        >
          Insurance
        </MenuItem>
        <MenuItem
          link="/application/products/investment"
          icon={<ShoppingCartIcon />}
        >
          Investment Funds
        </MenuItem>

        <MenuItem
          link="/application/products/recommendation"
          icon={<ShoppingCartIcon />}
        >
          Basis of Recommendation
        </MenuItem>

        <MenuItem
          link="/application/products/switching"
          icon={<ShoppingCartIcon />}
        >
          Policy Switch/Replace
        </MenuItem>
      </Menu>

      <Menu subHeading="Declaration & Documents">
        <MenuItem
          link="/application/declaration/declaration"
          icon={<ShoppingCartIcon />}
        >
          Declaration
        </MenuItem>
        <MenuItem
          link="/application/declaration/additionalforms"
          icon={<ShoppingCartIcon />}
        >
          Additional Forms
        </MenuItem>
      </Menu>

      <Menu subHeading="Review & Submit">
        <MenuItem
          link="/application/review/report/"
          icon={<ShoppingCartIcon />}
        >
          Generate PDF
        </MenuItem>
        <MenuItem
          link="/application/review/additionalforms"
          icon={<ShoppingCartIcon />}
        >
          Upload Documents
        </MenuItem>
      </Menu>

      {/* 
        <Menu subHeading="OTHERS">
          <Submenu title="Menu Level">
            <MenuItem>Post</MenuItem>
            <MenuItem>Details</MenuItem>
            <Submenu title="Level 2">
              <MenuItem>new</MenuItem>
              <MenuItem>Hello</MenuItem>
            </Submenu>
          </Submenu>

          <MenuItem>Chip</MenuItem>
          <MenuItem
            target="_blank"
            //   component={Link}
            link="https://google.com"
          >
            External Link
          </MenuItem>
        </Menu> */}
    </Sidebar>
  );
}
